import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import axios from 'axios';
import '../css/style.css'; // Previously: './Events.css';
import Logo from '../assets/logo.svg'; // Import SVG direktno kao komponentu
import ScrollableFilter from '../components/ScrollableFilter';
import ImageSlider from '../components/ImageSlider'; // Import komponente za slajder

const Events = () => {
    const { slug } = useParams(); // Dohvati slug iz URL-a
    const [events, setEvents] = useState([]); // Podaci za događaje
    const [categories, setCategories] = useState([]); // Kategorije za filter
    const [filteredEvents, setFilteredEvents] = useState([]); // Filterovani rezultati
    const [activeFilter, setActiveFilter] = useState('All'); // Aktivni filter
    const [sliderImages, setSliderImages] = useState([]); // Slike za slajder
    const [coverImage, setCoverImage] = useState('/images/default.jpg'); // Default slika
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchData = async () => {
            try {
                // Dohvati sve kategorije iz tabele events za odabrani smeštaj
                const categoriesResponse = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/accommodations/${slug}/event-categories`);
                setCategories([{ name: 'All' }, ...categoriesResponse.data]);

                // Dohvati sve događaje vezane za ovaj smeštaj
                const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/accommodations/${slug}/events`);
                // Sortiraj događaje prema datumu (najskoriji događaji prvi)
                const sortedEvents = response.data.sort((a, b) => new Date(a.date) - new Date(b.date));
                setEvents(sortedEvents);
                setFilteredEvents(sortedEvents); // Inicijalno svi podaci

                // Dohvati slike za slajder i cover image
                const accommodationResponse = await axios.get(
                    `${process.env.REACT_APP_BACKEND_URL}/api/accommodations/${slug}`
                );

                const images = accommodationResponse.data.slider_images
                    ? accommodationResponse.data.slider_images
                        .split(';')
                        .map((img) => `${process.env.REACT_APP_BACKEND_URL}/${img}`)
                    : [];

                if (images.length > 0) {
                    setSliderImages(images); // Ako postoje slike, koristi ih za slajder
                } else if (accommodationResponse.data.cover_image) {
                    // Ako nema slika za slajder, koristi cover_image
                    setCoverImage(`${process.env.REACT_APP_BACKEND_URL}/${accommodationResponse.data.cover_image}`);
                }

                setLoading(false);
            } catch (err) {
                console.error('Error fetching events:', err);
                setError('Failed to load events.');
                setLoading(false);
            }
        };

        fetchData();
    }, [slug]); // Re-fetch podataka kada se slug promeni

    const handleFilterChange = (filter) => {
        setActiveFilter(filter);
        if (filter === 'All') {
            setFilteredEvents(events); // Prikazuje sve
        } else {
            setFilteredEvents(events.filter(event => event.category_name === filter));
        }
    };

    const formatDate = (dateString) => {
        const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
        const date = new Date(dateString);
        return date.toLocaleDateString('en-GB', options).replace(/\//g, '.'); // Format DD.MM.YYYY
    };

    if (loading) {
        return (
            <div style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100vh',
                fontFamily: 'Montserrat, sans-serif',
                backgroundColor: 'rgba(255, 255, 255, 0.7)', // Transparentna pozadina
            }}>
                <img
                    src={Logo} // Ucitavanje SVG fajla
                    alt="Loading logo"
                    style={{ width: '150px', marginBottom: '20px' }} // Stil za logo
                />
                <p style={{ fontSize: '20px', fontWeight: 'bold', margin: '0' }}>Loading...</p>
            </div>
        );
    }

    if (error) {
        return <p>{error}</p>;
    }

    if (!events.length) {
        return (
            <p>No events available for this accommodation.</p>
        );
    }

    return (
        <div className="events-page">
            <div className="header-slider">
                {sliderImages.length > 0 ? (
                    <ImageSlider images={sliderImages} />
                ) : (
                    <div
                        className="header-image"
                        style={{
                            backgroundImage: `url(${coverImage})`, // Slika u gornjem delu
                            backgroundSize: 'cover',
                            backgroundPosition: 'center',
                            height: '300px',
                            width: '100vw',
                        }}
                    />
                )}
            </div>

            <div className="content-boxed">
                <div className="breadcrumb-container">
                    <p className="breadcrumb">
                        <Link to={`/accommodations/${slug}`} className="breadcrumb-link">Home</Link>
                        <span className="breadcrumb-divider"> &gt; </span>
                        <span className="current-page">Events</span>
                    </p>
                </div>

                {/* Filter dugmadi */}
                <ScrollableFilter className="filter-section">
                    {categories.map((category, index) => (
                        <button
                            key={index}
                            className={category.name === activeFilter ? 'active' : ''}
                            onClick={() => handleFilterChange(category.name)}
                        >
                            {category.name}
                        </button>
                    ))}
                </ScrollableFilter>

                {/* Prikazivanje događaja */}
                <div className="gallery">
                    {filteredEvents.map((event, index) => (
                        <Link
                            to={`/accommodations/${slug}/events/${event.id}`}
                            className="gallery-item"
                            key={index}
                        >
                            <img 
                                src={event.image ? `${process.env.REACT_APP_BACKEND_URL}/${event.image}` : '/storage/images/noimage.jpg'} 
                                alt={event.name || 'No name available'} 
                            />
                            <div className="event-info">
                                <h3>{event.name || 'No name available'}</h3>
                                <p><strong>Location:</strong> {event.location || 'Not specified'}</p>
                                <p><strong>Date:</strong> {formatDate(event.date) || 'No date available'}</p>
                            </div>
                        </Link>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default Events;
